import { TransactionRequestCardOpTypes } from "src/app/card-operations-core/models/transaction-request-models";

export const getBodyCreator = (card_op_type:TransactionRequestCardOpTypes) => {
    if(card_op_type === 'card-save'){
        return new TransactionReqSaveCardBodyCreator();
    }else if(card_op_type === 'pay-with-credit-card'){
        return new TransactionReqCreditCardBodyCreator();
    }else if(card_op_type === 'pay-with-defined-card'){
        return new TransactionReqDefinedCardBodyCreator();
    }else if(card_op_type === 'etisalat'){
        return new TransactionReqEtisalatBodyCreator();
    }
    else{
        throw new Error('undefined body creator type!')
    }
}

export abstract class TransactionReqAbstractBodyCreator<T>{

    setBody = (params:T) : URLSearchParams => {
        return new URLSearchParams();
    }

}

class TransactionReqSaveCardBodyCreator<T> extends TransactionReqAbstractBodyCreator<T>{

    setBody = (saveCardOpParams:T | null = null) : URLSearchParams => {
        let body = new URLSearchParams();

        body.set('payment_type', '14');
        body.set('transaction_type', '4');

        return body;
    }

}

class TransactionReqCreditCardBodyCreator<T> extends TransactionReqAbstractBodyCreator<T>{

    setBody = (creditCardOpParams:T | null = null) : URLSearchParams => {
        let body = new URLSearchParams();

        body.set('payment_type', '13');
        body.set('transaction_type', '7');

        Object.entries(creditCardOpParams!).forEach(
            ([key, value]) => {
                body.set(key, value)
            }
        );

        const card_type = localStorage.getItem('card-type')!

        body.set('card_type', card_type);
        body.set('product_code', '10-1');
        body.set('product_type', '0');
        body.set('price', '{\"product_price\": \"0\",\"max_charge_amount\": 200,\"min_charge_amount\": 10,\"card_max_balance\": 200,\"predefined_amount\": [{\"type\": 1,\"amount\": 10},{\"type\": 2,\"amount\": 20},{\"type\": 3,\"amount\": 30},{\"type\": 7,\"amount\": 50},{\"type\": 8,\"amount\": 100}]}');
        body.set('passenger_type', '01');
        body.set('media_type', '00');
        body.set('totalAmount', '10');

        return body;
    }

}

class TransactionReqDefinedCardBodyCreator<T> extends TransactionReqAbstractBodyCreator<T>{

    setBody = (definedCardOpParams:T) : URLSearchParams => {
        let body = new URLSearchParams();

        body.set('payment_type', '15');
        body.set('transaction_type', '7');

        Object.entries(definedCardOpParams).forEach(
            ([key, value]) => {
                body.set(key, value)
            }
        );

        const card_type = localStorage.getItem('card-type')!;

        body.set('card_type', card_type);
        body.set('product_code', '10-1');
        body.set('product_type', '0');
        body.set('price', '{\"product_price\": \"0\",\"max_charge_amount\": 200,\"min_charge_amount\": 10,\"card_max_balance\": 200,\"predefined_amount\": [{\"type\": 1,\"amount\": 10},{\"type\": 2,\"amount\": 20},{\"type\": 3,\"amount\": 30},{\"type\": 7,\"amount\": 50},{\"type\": 8,\"amount\": 100}]}');
        body.set('passenger_type', '01');
        body.set('media_type', '00');
        body.set('totalAmount', '10');
        
        return body;
    }

}

class TransactionReqEtisalatBodyCreator<T> extends TransactionReqAbstractBodyCreator<T>{
    setBody = (etisalatReqParams:T) : URLSearchParams => {
        let body = new URLSearchParams();

        body.set('payment_type', '24');
        body.set('transaction_type', '6');

        Object.entries(etisalatReqParams).forEach(
            ([key, value]) => {
                body.set(key, value)
            }
        );

        // body.set('price', '{"product_price":"0","max_charge_amount":200,"min_charge_amount":10,"card_max_balance":200,"predefined_amount":[]}');
        // body.set('product_code', '11-1');
        // body.set('product_type', '0');
        // body.set('media_type', '93');
        body.set('passenger_type','01');
        body.set('payment_method','card');
        // body.set('totalAmount', '10');

        return body;
    }
}